var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "station" }, [
    _c("div", [
      _c("h2", { staticClass: "station__title" }, [
        _vm._v("Station " + _vm._s(_vm.station.name))
      ]),
      _vm._v(" "),
      _vm.stopped
        ? _c("p", { staticClass: "station__subtitle" }, [
            _vm._v("Gestopt op " + _vm._s(_vm.stopped.format("DD-MM-YYYY")))
          ])
        : _vm.started
        ? _c("p", { staticClass: "station__subtitle" }, [
            _vm._v("Gestart op " + _vm._s(_vm.started.format("DD-MM-YYYY")))
          ])
        : _c("p", { staticClass: "station__subtitle" }, [
            _vm._v("Nog niet gestart")
          ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button station__start-button",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.select()
          }
        }
      },
      [_vm._v("Start station")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }